import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import { OutboundLink } from 'gatsby-plugin-google-analytics'
import ExternalLink from '@material-ui/icons/Launch'

require('./../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/WPS_WLAN_Schnellverbindung_mit_einer_AVM_FritzBox.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>WPS / WLAN Schnellverbindung mit einer AVM Fritz!Box. Auf <OutboundLink href="https://www.youtube.com/watch?v=UEVZMmb5q3I" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)